module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_76-d72058d6bf7359a6bbe9a323eb1d5438.png";